import React from 'react';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';
import T from 'i18n-react';
import classnames from 'classnames';
import Lang from './services/Lang';

const HrbTranslate = props => {

    const { text, params, className, allowSelection, truncateText } = props;     
    const language = useSelector(state => (state.layout.lang || 'EN').toUpperCase())

    const classNames = classnames(className, {
        "is-unselectable": allowSelection !== true,
        "truncate-text": truncateText === true,
    })
    var isRed = text && text.includes("StyleRed");
    var isPhoneInFrench = text && text.includes("Phone") && language == 'FR';
    if (isPhoneInFrench && params && params.Phone)
        params.Phone = params.Phone.replace(/[()\s]/g, ' ');    
    return text
        ? isRed ?
            <T.span id="hrb-translate-span" style={{ color: 'red' }} text={{ key: Lang.getKey(text, language), ...params }} className={classNames}  />
            : <T.span id="hrb-translate-span" text={{ key: Lang.getKey(text, language), ...params }} className={classNames} />
        : null
}

HrbTranslate.propTypes = {
    text: PropTypes.string,
    params: PropTypes.object,
    truncateText: PropTypes.bool,
    allowSelection: PropTypes.bool,
    className: PropTypes.string
};

export default HrbTranslate